import { NumericFormat } from "react-number-format";
import DiagonalCard from "../common/DiagonalCard";
import Hexagon from "../common/Hexagon";

/**
 * Cabecera del país elegido.
 *
 * Uno de los tres sitios del panel donde va la esquina diagonal: es la
 * identidad de la pantalla, no una tarjeta más.
 *
 * El costo por defecto se edita en línea, y debajo dice a qué se aplica: esa
 * relación —se usa sólo donde la ciudad no tiene costo propio— no estaba
 * escrita en ninguna parte y era la duda que más se repetía.
 */
export const LogisticsCountry = ({
  selectedCountry,
  countryShippingValue,
  setCountryShippingValue,
  editMode,
  setEditMode,
  handleSaveShippingCost,
  isPending,
  cityCount = 0,
  onAddCities,
}) => (
  <DiagonalCard cut={26} className="d-flex align-items-center gap-4 flex-wrap">

    <div className="d-flex align-items-center gap-3">
      <Hexagon size={54} color="#4B36F0" icon="ri-earth-line" />
      <div>
        <div style={{ fontSize: 20, fontWeight: 800, letterSpacing: "-0.025em" }}>
          {selectedCountry.name}
        </div>
        <div style={{ color: "#8A91AE", fontSize: 12.5, marginTop: 2 }}>
          Moneda: {selectedCountry.currency || "—"} · {cityCount}{" "}
          {cityCount === 1 ? "ciudad configurada" : "ciudades configuradas"}
        </div>
      </div>
    </div>

    <div
      style={{
        paddingLeft: 26,
        borderLeft: "1px solid #EDEFF6",
        minWidth: 0,
      }}
    >
      <label className="ui-label" htmlFor="country-shipping">
        Costo de envío por defecto
      </label>

      <div className="d-flex align-items-center gap-2 flex-wrap">
        <NumericFormat
          id="country-shipping"
          className="ui-input"
          style={{ width: 150, fontSize: 16, fontWeight: 700 }}
          prefix={`${selectedCountry.currency || "$"} `}
          thousandSeparator="."
          decimalSeparator=","
          decimalScale={2}
          fixedDecimalScale
          allowNegative={false}
          value={countryShippingValue}
          disabled={!editMode}
          onValueChange={(values) => setCountryShippingValue(values.value)}
          placeholder="Ej: 5.000"
        />

        {editMode ? (
          <button
            type="button"
            className="ui-btn ui-btn--primary"
            disabled={isPending}
            onClick={handleSaveShippingCost}
          >
            <i className="ri-check-line" /> {isPending ? "Guardando..." : "Guardar"}
          </button>
        ) : (
          <button
            type="button"
            className="ui-btn"
            onClick={() => setEditMode(true)}
          >
            <i className="ri-edit-line" /> Actualizar
          </button>
        )}
      </div>

      <div className="ui-hint">Se aplica a las ciudades sin costo propio.</div>
    </div>

    <button
      type="button"
      className="ui-btn ui-btn--primary ms-auto"
      onClick={onAddCities}
    >
      <i className="ri-add-line" /> Agregar ciudades
    </button>

  </DiagonalCard>
);
